export class ValidationRegex {
  public static email: RegExp = /^.+@[^\.].*\.[a-z]{2,}$/;
  public static url: RegExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
}
